import { mount, unmount } from 'redom';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import SecondLevelCTA from 'generics/components/second-level-cta';

import AddSigneesPanel from 'generics/components/basic-text-editor-slate/elements/signature-panel/add-signees-panel';

class AddSigneesButton {

  constructor(configuration) {

    this.signeeType = configuration.signeeType;
    this.panel = configuration.panel;
    this.placeholder = configuration.placeholder;
    this.onSigneesAdded = configuration.onSigneesAdded;

    this.button = new SecondLevelCTA({
      label: configuration.label,
      icon: SecondLevelCTA.icons.ADD,
      onClick: this.displayAddSigneesModal.bind(this)
    });

    this.el = this.button.el;

  }

  handleComplete(signees) {
    this.handleCancel();
    this.onSigneesAdded(signees);
  }

  handleCancel() {
    unmount(document.body, this.addSigneesPanel);
    this.addSigneesPanel = null;
  }

  displayAddSigneesModal() {

    this.addSigneesPanel = new AddSigneesPanel({
      signeeType: this.signeeType,
      panelId: this.panel._id,
      placeholder: this.placeholder,
      onComplete: this.handleComplete.bind(this),
      onCancel: this.handleCancel.bind(this)
    });

    mount(document.body, this.addSigneesPanel);

    const element = this.addSigneesPanel.el;
    const anchorElement = this.button.el;
    const viewportElement = void 0;
    const verticalOffset = 0;
    const horizontalOffset = 0;
    const startSide = 'bottom';
    const placeOnCenter = true;
    const positionableSides = ['top', 'bottom', 'left', 'right'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);
    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

    element.style.height = 'auto';

  }

}

export default AddSigneesButton;